import { formatLongDateUtc } from '@/shared/infra/format'

export type PromoAppliedDetails = {
  name?: string
  trialDays?: number
  trialEndsAt?: string
}

export function promoAppliedMessage(promo: PromoAppliedDetails): string {
  const base = `${promo.name ?? 'Promo code'} applied.`
  const trialEndDate = formatLongDateUtc(promo.trialEndsAt)
  if (trialEndDate) {
    return `${base} Free until ${trialEndDate}.`
  }
  if (promo.trialDays) {
    return `${base} Includes a ${promo.trialDays}-day free trial.`
  }
  return base
}
